import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface ChangesListEditorProps {
  value: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
}

export function ChangesListEditor({
  value,
  onChange,
  placeholder = "Describe a change…",
}: ChangesListEditorProps) {
  const updateAt = (index: number, next: string) => {
    const copy = [...value];
    copy[index] = next;
    onChange(copy);
  };

  const removeAt = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const addRow = () => onChange([...value, ""]);

  return (
    <div className="space-y-2">
      {value.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          No changes added yet.
        </p>
      ) : (
        <ul className="space-y-2">
          {value.map((change, index) => (
            <li key={index} className="flex items-center gap-2">
              <span className="text-muted-foreground">•</span>
              <Input
                value={change}
                placeholder={placeholder}
                onChange={(e) => updateAt(index, e.target.value)}
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => removeAt(index)}
                aria-label="Remove change"
              >
                <Trash2 className="size-4 text-muted-foreground" />
              </Button>
            </li>
          ))}
        </ul>
      )}
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={addRow}
        className="gap-2"
      >
        <Plus className="size-4" />
        Add change
      </Button>
    </div>
  );
}
